export const SET_LANGUAGE = 'SET_LANGUAGE';
export interface LangState {
    language: string;
}
interface setLanguageAction {
    type: typeof SET_LANGUAGE;
    payload: string;
}
export type LangAction = setLanguageAction;

export const SET_ACCESSIBILITY = 'SET_ACCESSIBILITY';
export interface AccessState {
    Accessibility: string;
}
interface setAccessAction {
    type: typeof SET_ACCESSIBILITY;
    payload: string;
}
export type AccessAction = setAccessAction;

export const SET_BUILDINGID = 'SET_BUILDINGID';
export interface BuildingIdState {
    BuildingId: string;
}
interface setbuildingIdAction {
    type: typeof SET_BUILDINGID;
    payload: string;
}
export type BuildingIdAction = setbuildingIdAction;
